import type {
  MyRegistration,
  MyMatchesResponse,
  PlayerProfile,
} from '@swiss-magic/shared-types';
import { get, post } from './core';

// Story 010 — Player self-report on My Matches.
export function selfReportMatch(
  tournamentId: string,
  roundNumber: number,
  tableNumber: number,
  perspective: 'win' | 'draw' | 'loss',
): Promise<{ result: string; resultStatus: string; reportedBy: string }> {
  return post(
    `/tournaments/${tournamentId}/rounds/${roundNumber}/matches/${tableNumber}/self-report`,
    { result: perspective },
  );
}

// Story 010b — Opponent confirm/dispute on a player-self-reported result.
export function respondToMatch(
  tournamentId: string,
  roundNumber: number,
  tableNumber: number,
  action: 'confirm' | 'dispute',
): Promise<
  | { ok: true; alreadyHandled: false; finalized: boolean }
  | { ok: true; alreadyHandled: true }
> {
  return post(
    `/tournaments/${tournamentId}/rounds/${roundNumber}/matches/${tableNumber}/respond`,
    { action },
  );
}

export function getMyRegistrations(): Promise<MyRegistration[]> {
  return get<MyRegistration[]>('/player/tournaments');
}

export function getMyMatches(slug: string): Promise<MyMatchesResponse> {
  return get<MyMatchesResponse>(`/player/tournaments/${slug}/matches`);
}

export function getOpponentProfile(
  slug: string,
  playerId: string,
): Promise<PlayerProfile> {
  return get<PlayerProfile>(
    `/player/tournaments/${slug}/players/${playerId}/profile`,
  );
}
